import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useT } from "@/lib/i18n";
import { CAUSES } from "@/lib/causes";

export default function Stories() {
  const { t, lang } = useT();
  const [params, setParams] = useSearchParams();
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const cause = params.get("cause") || "";

  useEffect(() => {
    setLoading(true);
    api.get(`/stories${cause ? `?cause=${cause}` : ""}`).then((r) => setStories(r.data.stories || [])).finally(() => setLoading(false));
  }, [cause]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
      <div className="max-w-2xl">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-brand">{t("stories.title")}</h1>
        <p className="text-stone-600 mt-2">{t("stories.sub")}</p>
      </div>

      <div className="flex flex-wrap gap-2 mt-6">
        <button onClick={() => setParams({})} data-testid="story-filter-all"
          className={`px-3 py-1.5 rounded-full text-sm font-medium border ${!cause ? "bg-slate-brand text-white border-slate-brand" : "bg-white text-stone-600 border-stone-200"}`}>All</button>
        {CAUSES.filter((c) => ["water", "waste", "education", "artisan", "agriculture", "women"].includes(c.id)).map((c) => (
          <button key={c.id} onClick={() => setParams({ cause: c.id })} data-testid={`story-filter-${c.id}`}
            className={`px-3 py-1.5 rounded-full text-sm font-medium border ${cause === c.id ? "bg-slate-brand text-white border-slate-brand" : "bg-white text-stone-600 border-stone-200"}`}>
            {lang === "ta" ? c.name_ta : c.name}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid md:grid-cols-3 gap-6 mt-8">{[...Array(3)].map((_, i) => <div key={i} className="h-72 rounded-xl bg-stone-100 animate-pulse" />)}</div>
      ) : (
        <div className="grid md:grid-cols-3 gap-6 mt-8">
          {stories.map((s) => (
            <Link key={s.id} to={`/stories/${s.slug}`} data-testid={`story-card-${s.slug}`} className="group bg-white rounded-xl border border-stone-200 overflow-hidden hover:shadow-lg transition-shadow">
              <div className="aspect-video overflow-hidden">
                <img src={s.hero_image} alt={s.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <span className="text-xs font-semibold uppercase tracking-wide text-terracotta">{s.district}</span>
                <h2 className="text-lg font-bold text-stone-900 mt-1 leading-snug">{s.title}</h2>
                <p className="text-sm text-stone-600 mt-2 line-clamp-3">{s.standfirst}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
